import { render } from "./MediaField.vue?vue&type=template&id=7627b780&scoped=true&ts=true"
import script from "./MediaField.vue?vue&type=script&lang=ts"
export * from "./MediaField.vue?vue&type=script&lang=ts"

import "./MediaField.vue?vue&type=style&index=0&id=7627b780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7627b780"]])

export default __exports__